(function () {
  if (customElements.get('product-gallery-custom')) return;

  var VISIBLE = 5;
  var STEP = 120; // thumb (108) + gap (12)

  class ProductGalleryCustom extends HTMLElement {
    connectedCallback() {
      this.count = parseInt(this.dataset.count, 10) || 0;
      this.active = 0;
      this.windowStart = 0;
      this.mActive = 0;
      this.mTarget = 0; // last slide a swipe/arrow aimed at, for chaining fast flicks

      // desktop refs
      this.thumbsTrack = this.querySelector('.pgc__thumbs-track');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.pgc__thumb'));
      this.mainTrack = this.querySelector('.pgc__main-track');
      this.dPrev = this.querySelector('.pgc__desktop .pgc__arrow--prev');
      this.dNext = this.querySelector('.pgc__desktop .pgc__arrow--next');

      // mobile refs
      this.scroller = this.querySelector('.pgc__scroller');
      this.mPrev = this.querySelector('.pgc__mobile .pgc__arrow--prev');
      this.mNext = this.querySelector('.pgc__mobile .pgc__arrow--next');
      this.barThumb = this.querySelector('.pgc__bar-thumb');
      this.mThumbsWrap = this.querySelector('.pgc__mthumbs');
      this.mThumbs = Array.prototype.slice.call(this.querySelectorAll('.pgc__mthumb'));
      this.mSwatches = Array.prototype.slice.call(this.querySelectorAll('.pgc__mswatch'));
      // Variant radios live in the sibling buy box; this is our shared source of truth.
      this.scope = this.closest('.shopify-section') || document;

      this.bind();
      this.renderDesktop();
      this.renderMobileBar();
      this.syncSwatchActive();
    }

    bind() {
      var self = this;
      this.thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.setActive(parseInt(btn.dataset.index, 10));
        });
      });
      if (this.dPrev) this.dPrev.addEventListener('click', function () { self.go(-1); });
      if (this.dNext) this.dNext.addEventListener('click', function () { self.go(1); });

      if (this.scroller) {
        this.scroller.addEventListener('scroll', function () { self.onMobileScroll(); }, { passive: true });
        this.enableTouch();
        this.enableDrag();
      }
      if (this.mPrev) this.mPrev.addEventListener('click', function () { self.scrollToSlide(self.mActive - 1); });
      if (this.mNext) this.mNext.addEventListener('click', function () { self.scrollToSlide(self.mActive + 1); });

      this.mThumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.scrollToSlide(parseInt(btn.dataset.mindex, 10));
        });
      });

      // Overlay colour swatches: tap selects the matching variant radio in the
      // buy box. The section's own change handler then resolves the variant,
      // updates the price, and slides the gallery to that colour's image.
      this.mSwatches.forEach(function (btn) {
        btn.addEventListener('click', function () { self.selectColor(btn.dataset.color); });
      });
      if (this.mSwatches.length) {
        var radios = this.scope.querySelectorAll('input[data-pis-option="0"]');
        Array.prototype.forEach.call(radios, function (r) {
          r.addEventListener('change', function () { self.syncSwatchActive(); });
        });
      }
    }

    /* Reflect a colour pick onto the real variant radio (fires its change). */
    selectColor(val) {
      if (val == null) return;
      var sel = 'input[data-pis-option="0"][value="' + val.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]';
      var radio = this.scope.querySelector(sel);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.syncSwatchActive(val);
    }

    /* Mark the active overlay swatch from the currently-checked colour radio. */
    syncSwatchActive(val) {
      if (!this.mSwatches.length) return;
      if (val == null) {
        var checked = this.scope.querySelector('input[data-pis-option="0"]:checked');
        val = checked ? checked.value : null;
      }
      this.mSwatches.forEach(function (b) {
        var on = b.dataset.color === val;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    /* Finger swipe for the mobile carousel.
       We don't rely on the browser's native touch scroll-snap here — something in
       the live page (an app script) is swallowing it, so the scroller only moved
       via the arrows. Instead we read the touch ourselves and set scrollLeft
       directly (the same mechanism the arrows use, which is known to work).
       Axis lock: horizontal drags swipe the carousel; vertical drags are left
       alone so the page still scrolls. Releases snap to one image at a time. */
    enableTouch() {
      var self = this;
      var startX = 0, startY = 0, lastX = 0, startScroll = 0, startT = 0;
      var axis = null, active = false;

      this.scroller.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        active = true;
        axis = null;
        // Halt any in-flight smooth scroll from a previous flick, otherwise it
        // fights this drag and the carousel stutters on fast successive swipes.
        self.scroller.scrollTo({ left: self.scroller.scrollLeft, behavior: 'auto' });
        startX = lastX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startScroll = self.scroller.scrollLeft;
        startT = Date.now();
      }, { passive: true });

      this.scroller.addEventListener('touchmove', function (e) {
        if (!active) return;
        var x = e.touches[0].clientX;
        var dx = x - startX;
        var dy = e.touches[0].clientY - startY;
        if (axis === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; // ignore tiny jitter
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x') self.scroller.classList.add('is-dragging');
        }
        if (axis === 'x') {
          e.preventDefault(); // claim the horizontal gesture from anything else
          lastX = x;
          self.scroller.scrollLeft = startScroll - dx;
          // Drive the bar directly: scroll events can be swallowed/throttled on
          // the live page, so the dash tracks the finger from here, not from them.
          self.barFromScroll();
        }
      }, { passive: false });

      var end = function () {
        if (!active) return;
        active = false;
        if (axis === 'x') {
          self.scroller.classList.remove('is-dragging');
          var width = self.scroller.clientWidth || 1;
          var dx = lastX - startX;
          var dt = Math.max(1, Date.now() - startT);
          var velocity = dx / dt; // px per ms; a light flick clears ~0.3
          // Chain off the last intended slide, not the mid-animation position,
          // so rapid flicks advance predictably one at a time.
          var base = Math.max(0, Math.min(self.count - 1, self.mTarget));
          // A quick flick OR a drag past ~20% of the width advances one image;
          // anything smaller/slower snaps back. Always one image at a time.
          var step = 0;
          if (Math.abs(velocity) > 0.3 || Math.abs(dx) > width * 0.2) {
            step = dx < 0 ? 1 : -1; // swipe left -> next, swipe right -> prev
          }
          self.scrollToSlide(base + step);
        } else {
          // Tap (or vertical scroll) that interrupted an animation: settle back
          // onto the intended slide so we never rest between two images.
          self.scrollToSlide(self.mTarget);
        }
        axis = null;
      };
      this.scroller.addEventListener('touchend', end);
      this.scroller.addEventListener('touchcancel', end);
    }

    /* Pointer drag-to-scroll for the mobile carousel.
       Touch is handled by enableTouch() above; this covers mouse/pen so the
       carousel also drags in the theme editor and on desktop, not just via the
       arrows. (Touch pointer events are skipped to avoid double-handling.) */
    enableDrag() {
      var self = this;
      var down = false, startX = 0, startScroll = 0;

      this.scroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // fingers: let native scroll-snap handle it
        down = true;
        startX = e.clientX;
        startScroll = self.scroller.scrollLeft;
        self.scroller.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        self.scroller.scrollLeft = startScroll - (e.clientX - startX);
        self.barFromScroll();
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        self.scroller.classList.remove('is-dragging');
        var step = self.slideStep();
        if (step) {
          self.scrollToSlide(Math.round(self.scroller.scrollLeft / step));
        }
      });
      // Stop the browser's native image-drag ghost from hijacking the gesture.
      this.scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* Desktop */
    setActive(i) {
      this.active = Math.max(0, Math.min(this.count - 1, i));
      var maxStart = Math.max(0, this.count - VISIBLE);
      if (this.active < this.windowStart) this.windowStart = this.active;
      else if (this.active > this.windowStart + VISIBLE - 1) this.windowStart = this.active - (VISIBLE - 1);
      this.windowStart = Math.min(Math.max(0, this.windowStart), maxStart);
      this.renderDesktop();
    }

    go(delta) { this.setActive(this.active + delta); }

    renderDesktop() {
      if (this.mainTrack) this.mainTrack.style.transform = 'translateX(-' + (this.active * 100) + '%)';
      if (this.thumbsTrack) this.thumbsTrack.style.transform = 'translateY(-' + (this.windowStart * STEP) + 'px)';
      this.thumbs.forEach(function (b, idx) {
        var on = idx === this.active;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      }, this);
      if (this.dPrev) this.dPrev.hidden = !(this.count > 1 && this.active > 0);
      if (this.dNext) this.dNext.hidden = !(this.count > 1 && this.active < this.count - 1);
    }

    /* Mobile */
    /* Pixel distance between two slides. Slides are full-width plus a small
       gap, so this is NOT exactly scroller.clientWidth — measure it live
       from the DOM so every scroll calc stays correct if the % or gap changes. */
    slideStep() {
      var slides = this.scroller ? this.scroller.children : null;
      if (slides && slides.length > 1) {
        var d = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
        if (d > 0) return d;
      }
      if (slides && slides.length) {
        var w = slides[0].getBoundingClientRect().width;
        if (w > 0) return w;
      }
      return this.scroller ? this.scroller.clientWidth : 0;
    }

    onMobileScroll() {
      var step = this.slideStep();
      if (!step) return;
      var i = Math.round(this.scroller.scrollLeft / step);
      if (i !== this.mActive) {
        this.mActive = Math.max(0, Math.min(this.count - 1, i));
        this.updateMobileArrows();
        this.renderMobileThumbs();
      }
      // When native scroll events DO fire (smooth scroll, momentum), let the
      // dash track the real position continuously.
      this.barFromScroll();
    }

    scrollToSlide(i) {
      if (!this.scroller) return;
      var t = Math.max(0, Math.min(this.count - 1, i));
      this.mTarget = t;
      // Commit the destination immediately. The CSS `left` transition slides
      // the dash there even if no scroll event ever fires (app scripts on the
      // page are known to swallow them), so the bar can never get stuck.
      this.mActive = t;
      this.renderMobileBar();
      this.renderMobileThumbs();
      this.scroller.scrollTo({ left: t * this.slideStep(), behavior: 'smooth' });
    }

    /* Mobile thumbnail strip: mark the active rectangle and keep it in view as
       the carousel moves (swipe, arrows, or thumb tap all route through here). */
    renderMobileThumbs() {
      if (!this.mThumbs || !this.mThumbs.length) return;
      var active = null;
      this.mThumbs.forEach(function (b, idx) {
        var on = idx === this.mActive;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) active = b;
      }, this);
      // Scroll the strip itself (not the page) so the active thumb stays centered.
      if (active && this.mThumbsWrap) {
        var wrap = this.mThumbsWrap;
        var target = active.offsetLeft - (wrap.clientWidth - active.clientWidth) / 2;
        wrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    }

    /* Dash position proportional to the actual scroll offset: left runs
       0% -> (100 - seg)% as the scroller runs start -> end, which lands the
       dash exactly on the discrete per-image stops (i * seg) at rest while
       letting it follow the finger live mid-drag. No transition here — it
       tracks 1:1; the eased slide is renderMobileBar's job. */
    barFromScroll() {
      if (!this.barThumb || this.count <= 1) return;
      var w = this.scroller.clientWidth;
      if (!w) return;
      var seg = 100 / this.count;
      var max = (this.count - 1) * w;
      var f = max > 0 ? this.scroller.scrollLeft / max : 0;
      f = Math.max(0, Math.min(1, f));
      this.barThumb.style.width = seg + '%';
      this.barThumb.style.transition = 'none';
      this.barThumb.style.left = (f * (100 - seg)) + '%';
    }

    renderMobileBar() {
      if (this.count <= 1) return;
      if (this.barThumb) {
        // The dash is one image-slot wide (100 / count %) and steps across the
        // white bar by its own width per image: 0%, seg%, 2*seg% ... up to the
        // last image at the right edge, then back the same way. CSS transitions
        // `left`, so each step slides smoothly.
        var seg = 100 / this.count;
        this.barThumb.style.width = seg + '%';
        this.barThumb.style.transition = '';
        this.barThumb.style.left = (this.mActive * seg) + '%';
      }
      this.updateMobileArrows();
    }

    updateMobileArrows() {
      if (this.mPrev) this.mPrev.hidden = !(this.mActive > 0);
      if (this.mNext) this.mNext.hidden = !(this.mActive < this.count - 1);
    }
  }

  if (!customElements.get('product-gallery-custom')) {
    customElements.define('product-gallery-custom', ProductGalleryCustom);
  }
})();
